import ConfirmModal from '../UI/Modal/confirmModal';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { deletePlan } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';

const DeletePlanModal = ({ setSelectedAction, selectedPlan, setSelectedPlan, getPlans }) => {
    const [loading, setLoading] = useState(false);
    const { userData } = useUserContext();

    const handleDelete = async () => {
        setLoading(true);
        try {
            const res = await deletePlan(userData?.token, userData?.selectedOrganization?.org_token, selectedPlan._id);
            if (res.status) {
                toast.success(res.message);
                getPlans();
                setSelectedPlan(null);
                setSelectedAction('');
            }
        } catch (error) {
            toast.error('Failed to delete the plan.');
            console.log('Delete Plan error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfirmModal
            title="Delete Plan"
            description="Are you sure you want to delete this plan?"
            ConfirmText="Delete"
            loading={loading}
            hideModal={() => setSelectedAction('')}
            handleConfirmation={handleDelete}
        />
    );
};

export default DeletePlanModal;